import { api } from './api';

// The true owners screen. One capture, territory-wide: there is no scope to
// pass, only the switch and the budget.
export const trueOwnersApi = {
    status: () => api.get('/true-owners').then((res) => res.data),
    start: () => api.post('/true-owners/start').then((res) => res.data),
    pause: () => api.post('/true-owners/pause').then((res) => res.data),
    resume: () => api.post('/true-owners/resume').then((res) => res.data),
    stop: () => api.post('/true-owners/stop').then((res) => res.data),
    saveSettings: (settings) => api.post('/true-owners/settings', settings).then((res) => res.data),

    // The whole envelope: meta carries the page count.
    runs: (page) => api.get('/true-owners/runs', { page }),
    // What one pass did, parcel by parcel — the same endpoint the listing screen reads.
    runItems: (runId, outcome, page) => api.get('/process-runs/' + runId + '/items', { outcome, page }),
};
